import React from "react"

const OwnerLabel: React.FC<{ text: string }> = (text): JSX.Element => {
  return <span className="text-sm text-white px-2 rounded bg-ch-blue-500 ml-2">{text} </span>
}

export default OwnerLabel
